module.exports = __webpack_public_path__ + "img/user_login.a276f01.png";